<template>
  <el-tabs :value="defaultLang.key" type="card">
    <el-tab-pane :label="defaultLang.langName" :name="defaultLang.key">
      <slot name="main" v-bind:langkey="defaultLang.key"></slot>
    </el-tab-pane>
    <template v-for="(item, i) in this.$i18n.messages">
      <el-tab-pane
        :key="i"
        :label="item.langName"
        :name="item.key"
        v-if="item.key != defaultLang.key"
      >
        <slot name="other" v-bind:item="item"></slot>
      </el-tab-pane>
    </template>
  </el-tabs>
</template>
<script>
export default {
  name: "LangTabs",
  data() {
    return {
      defaultLang: {
        key: "zh_cn",
        langName: "中文",
      },
    };
  },
  props: {}, //接受父组件传值
  methods: {},
};
</script>